import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftLogoColored = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4 0H0V11.4H11.4V0Z",
			fill: "#F25022"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.9996 0H12.5996V11.4H23.9996V0Z",
			fill: "#7FBA00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4 12.6001H0V24.0001H11.4V12.6001Z",
			fill: "#00A4EF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.9996 12.6001H12.5996V24.0001H23.9996V12.6001Z",
			fill: "#FFB900"
		})
	]
});
export default SvgMicrosoftLogoColored;
